'use strict';

var React = require('react');
var lighthouseComponentLibrary = require('@workforcesoftware/lighthouse-component-library');
var lighthouseFramework = require('@workforcesoftware/lighthouse-framework');
var polished = require('polished');

function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n.default = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

var frameworkI18n;
var setFrameworkI18n = function (i18n) {
    frameworkI18n = i18n;
};
var translate = function (key) {
    return frameworkI18n.translate(key);
};

var setFrameworkInstance = function (lighthouseFramework) {
};

var RouteIds;
(function (RouteIds) {
    RouteIds["PayRulesEditor"] = "pay-rules-editor";
})(RouteIds || (RouteIds = {}));

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */


var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
}

var DEFAULT_RULE = {
    uiKey: 0,
    name: '',
    comparator: '',
    constraint: '',
    period: '',
    payCode: '',
    priority: 1,
};

var JSON_API_CONTENT_TYPE = "application/vnd.api+json";
/**
 * Returns auth headers for API requests.
 *
 * Local development only:
 * When REACT_APP_LOCAL_API_BASE_URL is set in .env.local (gitignored, never deployed),
 * the local backend at localhost:16900 does not use JWT auth. Instead it expects
 * X-Service-Secret and X-Account-Internal-Id headers for authentication.
 *
 * Deployed environments (latest, sprint, prod):
 * REACT_APP_LOCAL_API_BASE_URL is not set, so this falls through to the standard
 * Bearer token path using the authenticated user's access token.
 */
function getAuthHeaders() {
    var _a, _b;
    return __awaiter(this, void 0, void 0, function () {
        var accessToken;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (process.env.REACT_APP_LOCAL_API_BASE_URL) {
                        return [2 /*return*/, {
                                "X-Service-Secret": (_a = process.env.REACT_APP_LOCAL_SERVICE_SECRET) !== null && _a !== void 0 ? _a : "",
                                "X-Account-Internal-Id": (_b = process.env.REACT_APP_LOCAL_ACCOUNT_ID) !== null && _b !== void 0 ? _b : "",
                                "Content-Type": JSON_API_CONTENT_TYPE,
                                Accept: JSON_API_CONTENT_TYPE,
                            }];
                    }
                    return [4 /*yield*/, lighthouseFramework.AuthenticationManager.getInstance().getAccessToken()];
                case 1:
                    accessToken = _c.sent();
                    return [2 /*return*/, {
                            Authorization: "Bearer " + accessToken,
                            "Content-Type": JSON_API_CONTENT_TYPE,
                            Accept: JSON_API_CONTENT_TYPE,
                        }];
            }
        });
    });
}
/**
 * Generic fetch wrapper that attaches auth headers and handles common error status codes.
 * Throws UNAUTHORIZED on 401, PERMISSION_DENIED on 403, and the JSON:API error detail
 * message for other failures so the backend message is surfaced directly to the UI.
 */
function apiFetch(url, options) {
    if (options === void 0) { options = {}; }
    var _a, _b;
    return __awaiter(this, void 0, void 0, function () {
        var headers, response, body, detail, parseErr_1;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, getAuthHeaders()];
                case 1:
                    headers = _c.sent();
                    return [4 /*yield*/, fetch(url, __assign(__assign({}, options), { 
                            // Merge the impersonation session header (adp-acting-sessionid) when an
                            // impersonation session is active and the target is a WFS origin.
                            // No-op otherwise. (CHCERT-921)
                            headers: __assign(__assign({}, headers), lighthouseFramework.buildActingSessionHeader(url)) }))];
                case 2:
                    response = _c.sent();
                    if (response.status === 401) {
                        throw new Error("UNAUTHORIZED");
                    }
                    if (response.status === 403) {
                        throw new Error("PERMISSION_DENIED");
                    }
                    if (!!response.ok) return [3 /*break*/, 7];
                    _c.label = 3;
                case 3:
                    _c.trys.push([3, 5, , 6]);
                    return [4 /*yield*/, response.json()];
                case 4:
                    body = (_c.sent());
                    detail = (_b = (_a = body === null || body === void 0 ? void 0 : body.errors) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.detail;
                    if (detail)
                        throw new Error(detail);
                    return [3 /*break*/, 6];
                case 5:
                    parseErr_1 = _c.sent();
                    if (parseErr_1 instanceof Error &&
                        parseErr_1.message !== "API error: " + response.status) {
                        throw parseErr_1;
                    }
                    return [3 /*break*/, 6];
                case 6: throw new Error("API error: " + response.status + " " + response.statusText);
                case 7:
                    if (response.status === 204 ||
                        response.headers.get("content-length") === "0") {
                        return [2 /*return*/, undefined];
                    }
                    return [2 /*return*/, response.json()];
            }
        });
    });
}
/**
 * Derives the correct API gateway base URL from the account's deployment suffix and datacenter.
 *
 * URL mapping:
 * - latest  → https://iad-dit.api.us.wfs.cloud  (DIT environment)
 * - sprint  → https://iad-fit.api.us.wfs.cloud  (FIT environment)
 * - us0     → https://iad-uat.api.us.wfs.cloud  (UAT environment)
 * - us5     → https://api.ups.wfs.cloud          (UPS environment)
 * - default → https://api.<dc>.wfs.cloud         (derived from datacenter prefix)
 */
function deriveApiBaseUrl(accountDetail) {
    var _a;
    if (accountDetail.deploymentSuffix.includes("latest"))
        return "https://iad-dit.api.us.wfs.cloud";
    if (accountDetail.deploymentSuffix.includes("sprint"))
        return "https://iad-fit.api.us.wfs.cloud";
    var datacenter = (_a = accountDetail.datacenter) !== null && _a !== void 0 ? _a : "us";
    if (datacenter === "us0")
        return "https://iad-uat.api.us.wfs.cloud";
    if (datacenter === "us5")
        return "https://api.ups.wfs.cloud";
    return "https://api." + datacenter.substring(0, 2) + ".wfs.cloud";
}
/**
 * Returns the API gateway base URL for the current environment.
 *
 * Local development:
 * When REACT_APP_LOCAL_API_BASE_URL is set in .env.local (gitignored, never deployed),
 * returns it directly so the browser hits the local backend (e.g. http://localhost:16900)
 * directly. Quarkus handles CORS/OPTIONS by default so no proxy is needed.
 *
 * Deployed environments (latest, sprint, prod, uat):
 * Derives the correct API gateway URL from the account's deploymentSuffix and datacenter,
 * ensuring requests always reach the intended environment-specific gateway.
 * Falls back to the DIT gateway if account info is not yet available.
 */
function getApiBaseUrl() {
    var _a;
    if (process.env.REACT_APP_LOCAL_API_BASE_URL)
        return "";
    var accountInfo = lighthouseFramework.AuthenticationManager.getInstance().getAccountInfo();
    if ((_a = accountInfo === null || accountInfo === void 0 ? void 0 : accountInfo.accountData) === null || _a === void 0 ? void 0 : _a.accountDetail) {
        return deriveApiBaseUrl(accountInfo.accountData.accountDetail);
    }
    // Fallback to DIT if account info is not yet available during initialisation.
    return "https://iad-dit.api.us.wfs.cloud";
}

/**
 * Maps a JSON:API PayRuleResource to the internal RuleDefinition shape.
 */
function mapPayRuleResourceToDefinition(resource) {
    var _a, _b, _c, _d, _e, _f;
    return {
        uiKey: 0,
        apiId: resource.id,
        name: resource.attributes.name,
        payCode: resource.attributes.payCode,
        priority: resource.attributes.priority,
        comparator: (_b = (_a = resource.relationships) === null || _a === void 0 ? void 0 : _a.comparator.data.id) !== null && _b !== void 0 ? _b : '',
        constraint: (_d = (_c = resource.relationships) === null || _c === void 0 ? void 0 : _c.constraint.data.id) !== null && _d !== void 0 ? _d : '',
        period: (_f = (_e = resource.relationships) === null || _e === void 0 ? void 0 : _e.period.data.id) !== null && _f !== void 0 ? _f : '',
    };
}
/**
 * Maps an internal RuleDefinition to the JSON:API POST/PATCH request payload shape.
 * Includes `id` when present (required for PATCH).
 */
function mapRuleDefinitionToPayload(rule) {
    return {
        data: {
            type: 'payRule',
            id: rule.apiId,
            attributes: {
                name: rule.name,
                payCode: rule.payCode,
                priority: rule.priority,
            },
            relationships: {
                constraint: { data: { id: rule.constraint, type: 'constraint' } },
                comparator: { data: { id: rule.comparator, type: 'comparator' } },
                period: { data: { id: rule.period, type: 'period' } },
            },
        },
    };
}

var PAY_RULES_PATH = '/config/v1/pay-rules';
/**
 * Fetches all pay rules for the current tenant.
 * Maps the JSON:API response to the internal RuleDefinition shape.
 */
function fetchPayRules() {
    return __awaiter(this, void 0, void 0, function () {
        var data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, apiFetch("" + getApiBaseUrl() + PAY_RULES_PATH)];
                case 1:
                    data = _a.sent();
                    return [2 /*return*/, data.data.map(mapPayRuleResourceToDefinition)];
            }
        });
    });
}
/**
 * Creates a new pay rule.
 * Returns the created rule mapped to the internal RuleDefinition shape.
 */
function createPayRule(rule) {
    return __awaiter(this, void 0, void 0, function () {
        var data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, apiFetch("" + getApiBaseUrl() + PAY_RULES_PATH, {
                        method: 'POST',
                        body: JSON.stringify(mapRuleDefinitionToPayload(rule)),
                    })];
                case 1:
                    data = _a.sent();
                    return [2 /*return*/, mapPayRuleResourceToDefinition(data.data)];
            }
        });
    });
}
/**
 * Updates an existing pay rule via PATCH.
 * Returns the updated rule mapped to the internal RuleDefinition shape.
 */
function updatePayRule(rule) {
    return __awaiter(this, void 0, void 0, function () {
        var data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, apiFetch("" + getApiBaseUrl() + PAY_RULES_PATH + "/" + rule.apiId, {
                        method: 'PATCH',
                        body: JSON.stringify(mapRuleDefinitionToPayload(rule)),
                    })];
                case 1:
                    data = _a.sent();
                    return [2 /*return*/, mapPayRuleResourceToDefinition(data.data)];
            }
        });
    });
}
/**
 * Deletes an existing pay rule by its API ID.
 */
function deletePayRule(apiId) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, apiFetch("" + getApiBaseUrl() + PAY_RULES_PATH + "/" + apiId, { method: 'DELETE' })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}

var PAY_RULE_CONSTRAINTS_PATH = '/config/v1/pay-rule-constraints';
/**
 * Fetches available constraint, comparator and period options from the API.
 * Used to populate the dropdown fields in the rule definition form.
 */
function fetchPayRuleConstraints() {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var response, includedMap;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, apiFetch("" + getApiBaseUrl() + PAY_RULE_CONSTRAINTS_PATH)];
                case 1:
                    response = _b.sent();
                    includedMap = {};
                    ((_a = response.included) !== null && _a !== void 0 ? _a : []).forEach(function (item) {
                        includedMap[item.id] = { id: item.id, name: item.attributes.name };
                    });
                    return [2 /*return*/, response.data.map(function (constraint) {
                            var _a, _b, _c, _d;
                            return ({
                                id: constraint.id,
                                name: constraint.attributes.name,
                                comparators: ((_b = (_a = constraint.relationships) === null || _a === void 0 ? void 0 : _a.comparators) !== null && _b !== void 0 ? _b : []).map(function (rel) { return includedMap[rel.data.id]; }).filter(Boolean),
                                periods: ((_d = (_c = constraint.relationships) === null || _c === void 0 ? void 0 : _c.periods) !== null && _d !== void 0 ? _d : []).map(function (rel) { return includedMap[rel.data.id]; }).filter(Boolean),
                            });
                        })];
            }
        });
    });
}

var Container = lighthouseComponentLibrary.styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: ", ";\n"], ["\n  padding: ", ";\n"])), polished.rem('24px'));
var RuleRow = lighthouseComponentLibrary.styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: ", ";\n  padding: ", " ", ";\n  margin-bottom: ", ";\n  border-radius: ", ";\n  border: 1px solid ", ";\n  background: ", ";\n  transition: border-color 0.15s, background 0.15s;\n"], ["\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: ", ";\n  padding: ", " ", ";\n  margin-bottom: ", ";\n  border-radius: ", ";\n  border: 1px solid ", ";\n  background: ", ";\n  transition: border-color 0.15s, background 0.15s;\n"])), polished.rem('16px'), polished.rem('8px'), polished.rem('12px'), polished.rem('8px'), polished.rem('4px'), function (_a) {
    var isInEditMode = _a.isInEditMode;
    return isInEditMode ? '#1976d2' : 'transparent';
}, function (_a) {
    var isInEditMode = _a.isInEditMode;
    return isInEditMode ? '#f0f7ff' : 'transparent';
});
RuleRow.displayName = 'RuleRow'; // needed for enzyme selectors in tests (ts-jest does not run babel-plugin-styled-components)
lighthouseComponentLibrary.styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  gap: ", ";\n  margin-top: ", ";\n  margin-bottom: ", ";\n"], ["\n  display: flex;\n  gap: ", ";\n  margin-top: ", ";\n  margin-bottom: ", ";\n"])), polished.rem('10px'), polished.rem('12px'), polished.rem('16px'));
var StyledAddRuleButton = lighthouseComponentLibrary.styled(lighthouseComponentLibrary.Button)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  && {\n    padding-left: 0;\n    text-transform: none;\n  }\n"], ["\n  && {\n    padding-left: 0;\n    text-transform: none;\n  }\n"])));
StyledAddRuleButton.displayName = 'StyledAddRuleButton'; // needed for enzyme selectors in tests (ts-jest does not run babel-plugin-styled-components)
var RulesContainer = lighthouseComponentLibrary.styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  margin-top: ", ";\n"], ["\n  margin-top: ", ";\n"])), polished.rem('16px'));
var PrimaryIconButton = lighthouseComponentLibrary.styled(lighthouseComponentLibrary.IconButton)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  && {\n    padding: ", ";\n  }\n"], ["\n  && {\n    padding: ", ";\n  }\n"])), polished.rem('4px'));
PrimaryIconButton.displayName = 'PrimaryIconButton';
var DeleteIconButton = lighthouseComponentLibrary.styled(lighthouseComponentLibrary.IconButton)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  && {\n    padding: ", ";\n    color: #d32f2f;\n  }\n"], ["\n  && {\n    padding: ", ";\n    color: #d32f2f;\n  }\n"])), polished.rem('4px'));
DeleteIconButton.displayName = 'DeleteIconButton';
var InlineActions = lighthouseComponentLibrary.styled.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  align-self: flex-end;\n  gap: ", ";\n  padding-bottom: ", ";\n"], ["\n  display: flex;\n  align-items: center;\n  align-self: flex-end;\n  gap: ", ";\n  padding-bottom: ", ";\n"])), polished.rem('4px'), polished.rem('4px'));
InlineActions.displayName = 'InlineActions';
var RowActions = lighthouseComponentLibrary.styled.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  align-self: flex-end;\n  gap: ", ";\n  padding-bottom: ", ";\n"], ["\n  display: flex;\n  align-items: center;\n  align-self: flex-end;\n  gap: ", ";\n  padding-bottom: ", ";\n"])), polished.rem('4px'), polished.rem('4px'));
RowActions.displayName = 'RowActions';
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;

var BLANK_RULE = { uiKey: 1, name: '', comparator: '', constraint: '', period: '', payCode: '', priority: 1 };
// --- Initial State ---
function createInitialState(firstRule) {
    return {
        rules: [firstRule],
        serverRules: [],
        constraintOptions: [],
        pendingDeleteIndex: null,
        isLoading: true,
        hasUserAddedRows: false,
        toast: null,
    };
}
// --- Reducer ---
function payRulesReducer(state, action) {
    switch (action.type) {
        case 'LOAD_SUCCESS': {
            return {
                rules: action.rules.length > 0 ? action.rules : [BLANK_RULE],
                serverRules: action.rules,
                constraintOptions: action.constraintOptions,
                pendingDeleteIndex: null,
                isLoading: false,
                hasUserAddedRows: false,
                toast: null,
            };
        }
        case 'LOAD_FAILED': {
            return __assign(__assign({}, state), { isLoading: false, toast: { open: true, variant: 'error', message: action.error } });
        }
        case 'RULE_ADDED': {
            return __assign(__assign({}, state), { rules: state.rules.concat(action.newRule), hasUserAddedRows: true });
        }
        case 'NEW_ROW_CANCELLED': {
            var remaining = state.rules.filter(function (_, i) { return i !== action.index; });
            return __assign(__assign({}, state), { rules: remaining, hasUserAddedRows: remaining.some(function (r) { return !r.apiId; }) });
        }
        case 'DELETE_REQUESTED': {
            return __assign(__assign({}, state), { pendingDeleteIndex: action.index });
        }
        case 'DELETE_CANCELLED': {
            return __assign(__assign({}, state), { pendingDeleteIndex: null });
        }
        case 'RULE_DELETED': {
            var remaining = state.rules.filter(function (_, i) { return i !== action.index; });
            var serverRemaining = state.serverRules.filter(function (r) { var _a; return r.apiId !== ((_a = state.rules[action.index]) === null || _a === void 0 ? void 0 : _a.apiId); });
            return __assign(__assign({}, state), { rules: remaining, serverRules: serverRemaining, pendingDeleteIndex: null, toast: { open: true, variant: 'success', message: 'RULE_DEFINITION.SUCCESS.DELETE' } });
        }
        case 'SAVE_SUCCESS': {
            return __assign(__assign({}, state), { rules: action.savedRules, serverRules: action.savedRules, hasUserAddedRows: false, toast: { open: true, variant: 'success', message: 'RULE_DEFINITION.SUCCESS.SAVE' } });
        }
        case 'NEW_ROW_SAVE_SUCCESS': {
            var updatedRules = state.rules.map(function (r, i) { return i === action.index ? action.savedRule : r; });
            return __assign(__assign({}, state), { rules: updatedRules, serverRules: state.serverRules.concat(action.savedRule), hasUserAddedRows: updatedRules.some(function (r) { return !r.apiId; }), toast: { open: true, variant: 'success', message: 'RULE_DEFINITION.SUCCESS.SAVE' } });
        }
        case 'EDIT_SAVE_SUCCESS': {
            var updatedRules = state.rules.map(function (rule, i) { return i === action.index ? action.updatedRule : rule; });
            var updatedServerRules = state.serverRules.map(function (rule) {
                return rule.apiId === action.updatedRule.apiId ? action.updatedRule : rule;
            });
            return __assign(__assign({}, state), { rules: updatedRules, serverRules: updatedServerRules, toast: { open: true, variant: 'success', message: 'RULE_DEFINITION.SUCCESS.SAVE' } });
        }
        case 'SAVE_FAILED': {
            return __assign(__assign({}, state), { toast: { open: true, variant: 'error', message: action.error } });
        }
        case 'TOAST_DISMISSED': {
            return __assign(__assign({}, state), { toast: state.toast ? __assign(__assign({}, state.toast), { open: false }) : null });
        }
        default:
            return state;
    }
}

function getDropdownOptions(constraintOptions, constraintId, key) {
    if (constraintId) {
        var match = constraintOptions.find(function (c) { return c.id === constraintId; });
        return match ? match[key] : [];
    }
    var seen = new Set();
    return constraintOptions.reduce(function (acc, c) { return acc.concat(c[key]); }, []).filter(function (opt) {
        if (seen.has(opt.id))
            return false;
        seen.add(opt.id);
        return true;
    });
}
function isPriorityValid(raw, priority) {
    if (raw === undefined)
        return Number.isInteger(priority) && priority >= 1 && priority <= 999;
    var parsed = parseInt(raw, 10);
    return /^\d+$/.test(raw) && parsed >= 1 && parsed <= 999;
}
function isRowValid(rule, priorityRaw, constraintOptions, isExisting) {
    var hasName = rule.name.trim().length > 0;
    var hasConstraint = rule.constraint.trim().length > 0;
    var hasPayCode = rule.payCode.trim().length > 0;
    var hasComparator = rule.comparator.trim().length > 0;
    var hasPeriod = rule.period.trim().length > 0;
    var comparatorValid = isExisting
        ? hasComparator
        : getDropdownOptions(constraintOptions, rule.constraint, 'comparators').map(function (o) { return o.id; }).includes(rule.comparator);
    var periodValid = isExisting
        ? hasPeriod
        : getDropdownOptions(constraintOptions, rule.constraint, 'periods').map(function (o) { return o.id; }).includes(rule.period);
    return hasName && hasConstraint && hasPayCode && comparatorValid && periodValid && isPriorityValid(priorityRaw, rule.priority);
}
var PayRuleRow = function (_a) {
    var initialRule = _a.rule, index = _a.index, constraintOptions = _a.constraintOptions, isSaveInProgress = _a.isSaveInProgress, onNewRowSave = _a.onNewRowSave, onNewRowCancel = _a.onNewRowCancel, onEditSave = _a.onEditSave, onDeleteRequest = _a.onDeleteRequest;
    var isExistingRule = !!initialRule.apiId;
    // Local edit state — only active when isInEditMode is true
    var _b = React__namespace.useState(false), isInEditMode = _b[0], setIsInEditMode = _b[1];
    var _c = React__namespace.useState(initialRule), localRule = _c[0], setLocalRule = _c[1];
    var _d = React__namespace.useState(null), snapshot = _d[0], setSnapshot = _d[1];
    var _e = React__namespace.useState(false), isModified = _e[0], setIsModified = _e[1];
    var _f = React__namespace.useState(undefined), priorityRaw = _f[0], setPriorityRaw = _f[1];
    // Keep localRule in sync with parent for existing rules when not in edit mode (e.g. after a successful save from parent)
    // New rows (no apiId) own their local state entirely — never sync from parent
    React__namespace.useEffect(function () {
        if (isExistingRule && !isInEditMode)
            setLocalRule(initialRule);
    }, [initialRule, isExistingRule, isInEditMode]);
    var isReadOnly = isExistingRule && !isInEditMode;
    var activeRule = isInEditMode || !isExistingRule ? localRule : initialRule;
    var handleFieldChange = function (field, value) {
        if (field === 'priority') {
            setPriorityRaw(value);
            var parsed_1 = parseInt(value, 10);
            if (!isNaN(parsed_1) && parsed_1 >= 1 && parsed_1 <= 999) {
                setLocalRule(function (r) { return (__assign(__assign({}, r), { priority: parsed_1 })); });
            }
        }
        else {
            setLocalRule(function (r) {
                var _a;
                return (__assign(__assign({}, r), (_a = {}, _a[field] = value, _a)));
            });
        }
        if (isInEditMode)
            setIsModified(true);
    };
    var handlePriorityFocus = function () {
        if (priorityRaw === undefined)
            setPriorityRaw(String(activeRule.priority));
    };
    var handlePriorityBlur = function () {
        if (!priorityRaw) {
            setLocalRule(function (r) { return (__assign(__assign({}, r), { priority: 1 })); });
            setPriorityRaw('1');
            return;
        }
        var parsed = parseInt(priorityRaw, 10);
        // Remove raw input if invalid — falls back to last valid rule.priority
        if (isNaN(parsed) || parsed < 1 || parsed > 999)
            setPriorityRaw(undefined);
    };
    var handleEditStart = function () {
        setSnapshot(__assign({}, initialRule));
        setLocalRule(__assign({}, initialRule));
        setIsModified(false);
        setPriorityRaw(undefined);
        setIsInEditMode(true);
    };
    var handleEditCancel = function () {
        if (snapshot)
            setLocalRule(snapshot);
        setIsInEditMode(false);
        setIsModified(false);
        setPriorityRaw(undefined);
        setSnapshot(null);
    };
    var priorityDisplayValue = priorityRaw !== undefined ? priorityRaw : activeRule.priority;
    return (React__namespace.createElement(RuleRow, { key: activeRule.uiKey, isInEditMode: isInEditMode },
        React__namespace.createElement(lighthouseComponentLibrary.TextField, { "data-qa": "name-input-" + index, label: translate('RULE_DEFINITION.FIELD.NAME'), value: activeRule.name, onChange: function (e) { return handleFieldChange('name', e.target.value); }, style: { minWidth: '140px' }, disabled: isReadOnly }),
        React__namespace.createElement(lighthouseComponentLibrary.SelectV2, { "data-qa": "comparator-select-" + index, label: translate('RULE_DEFINITION.FIELD.COMPARATOR'), value: activeRule.comparator, onChange: function (e) { return handleFieldChange('comparator', e.target.value); }, style: { minWidth: '130px', borderRadius: '4px' }, disabled: isReadOnly }, getDropdownOptions(constraintOptions, activeRule.constraint, 'comparators').map(function (opt) { return (React__namespace.createElement(lighthouseComponentLibrary.Option, { key: opt.id, value: opt.id }, opt.name)); })),
        React__namespace.createElement(lighthouseComponentLibrary.SelectV2, { "data-qa": "constraint-select-" + index, label: translate('RULE_DEFINITION.FIELD.CONSTRAINT'), value: activeRule.constraint, onChange: function (e) { return handleFieldChange('constraint', e.target.value); }, style: { minWidth: '180px', borderRadius: '4px' }, disabled: isReadOnly }, constraintOptions.map(function (opt) { return (React__namespace.createElement(lighthouseComponentLibrary.Option, { key: opt.id, value: opt.id }, opt.name)); })),
        React__namespace.createElement(lighthouseComponentLibrary.SelectV2, { "data-qa": "period-select-" + index, label: translate('RULE_DEFINITION.FIELD.PERIOD'), value: activeRule.period, onChange: function (e) { return handleFieldChange('period', e.target.value); }, style: { minWidth: '170px', borderRadius: '4px' }, disabled: isReadOnly }, getDropdownOptions(constraintOptions, activeRule.constraint, 'periods').map(function (opt) { return (React__namespace.createElement(lighthouseComponentLibrary.Option, { key: opt.id, value: opt.id }, opt.name)); })),
        React__namespace.createElement(lighthouseComponentLibrary.TextField, { "data-qa": "paycode-input-" + index, label: translate('RULE_DEFINITION.FIELD.PAY_CODE'), value: activeRule.payCode, onChange: function (e) { return handleFieldChange('payCode', e.target.value); }, style: { minWidth: '120px' }, disabled: isReadOnly }),
        React__namespace.createElement(lighthouseComponentLibrary.TextField, { label: translate('RULE_DEFINITION.FIELD.PRIORITY'), type: "number", "data-qa": "priority-input", value: priorityDisplayValue, onChange: function (e) { return handleFieldChange('priority', e.target.value); }, onFocus: handlePriorityFocus, onBlur: handlePriorityBlur, inputProps: { min: 1, max: 999, style: { width: '80px' } }, disabled: isReadOnly }),
        !isExistingRule && (React__namespace.createElement(InlineActions, null,
            React__namespace.createElement(PrimaryIconButton, { "data-qa": "save-button-" + index, icon: "check", color: "primary", size: "medium", "aria-label": translate('RULE_DEFINITION.BUTTON.SAVE'), tooltipProps: { content: translate('RULE_DEFINITION.BUTTON.SAVE') }, onClick: function () { return onNewRowSave(index, localRule); }, disabled: isSaveInProgress || !isRowValid(localRule, priorityRaw, constraintOptions, false) }),
            React__namespace.createElement(PrimaryIconButton, { "data-qa": "cancel-button-" + index, icon: "close", color: "primary", size: "medium", "aria-label": translate('RULE_DEFINITION.BUTTON.CANCEL'), tooltipProps: { content: translate('RULE_DEFINITION.BUTTON.CANCEL') }, onClick: function () { return onNewRowCancel(index); }, disabled: isSaveInProgress }))),
        isExistingRule && !isInEditMode && (React__namespace.createElement(RowActions, null,
            React__namespace.createElement(PrimaryIconButton, { "data-qa": "edit-rule-button-" + index, icon: "pencil", color: "primary", size: "medium", "aria-label": translate('RULE_DEFINITION.BUTTON.EDIT'), tooltipProps: { content: translate('RULE_DEFINITION.BUTTON.EDIT') }, onClick: handleEditStart }),
            React__namespace.createElement(DeleteIconButton, { "data-qa": "delete-rule-button-" + index, icon: "trash", size: "medium", "aria-label": translate('RULE_DEFINITION.BUTTON.DELETE'), tooltipProps: { content: translate('RULE_DEFINITION.BUTTON.DELETE') }, onClick: function () { return onDeleteRequest(index); } }))),
        isInEditMode && (React__namespace.createElement(InlineActions, null,
            React__namespace.createElement(PrimaryIconButton, { "data-qa": "inline-save-button-" + index, icon: "check", color: "primary", size: "medium", "aria-label": translate('RULE_DEFINITION.BUTTON.SAVE'), tooltipProps: { content: translate('RULE_DEFINITION.BUTTON.SAVE') }, onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                    var success;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, onEditSave(index, localRule)];
                            case 1:
                                success = _a.sent();
                                if (success) {
                                    setIsInEditMode(false);
                                    setIsModified(false);
                                    setPriorityRaw(undefined);
                                    setSnapshot(null);
                                }
                                return [2 /*return*/];
                        }
                    });
                }); }, disabled: isSaveInProgress || !isModified || !isRowValid(localRule, priorityRaw, constraintOptions, true) }),
            React__namespace.createElement(PrimaryIconButton, { "data-qa": "cancel-edit-button-" + index, icon: "close", color: "primary", size: "medium", "aria-label": translate('RULE_DEFINITION.BUTTON.CANCEL_EDIT'), tooltipProps: { content: translate('RULE_DEFINITION.BUTTON.CANCEL_EDIT') }, onClick: handleEditCancel, disabled: isSaveInProgress })))));
};

/** Assigns a stable uiKey to a rule for use as a React key. Not the server-assigned API ID. */
function withUiKey(uiKey) {
    return __assign(__assign({}, DEFAULT_RULE), { uiKey: uiKey });
}
/** Returns the error message for a save failure, based on the error type. */
function getSaveErrorMessage(err) {
    var msg = err instanceof Error ? err.message : '';
    if (msg === 'PERMISSION_DENIED')
        return translate('RULE_DEFINITION.ERROR.PERMISSION_DENIED');
    if (msg === 'DUPLICATE_RULE')
        return translate('RULE_DEFINITION.ERROR.DUPLICATE_RULE');
    return msg || translate('RULE_DEFINITION.ERROR.SAVE_FAILED');
}
/** Returns the error message for a delete failure, based on the error type. */
function getDeleteErrorMessage(err) {
    var msg = err instanceof Error ? err.message : '';
    if (msg === 'PERMISSION_DENIED')
        return translate('RULE_DEFINITION.ERROR.PERMISSION_DENIED');
    return msg || translate('RULE_DEFINITION.ERROR.DELETE_FAILED');
}
/** Returns true if two rule definitions have identical field values (ignoring uiKey and apiId). */
function rulesAreEqual(a, b) {
    return a.name === b.name
        && a.comparator === b.comparator
        && a.constraint === b.constraint
        && a.period === b.period
        && a.payCode === b.payCode
        && Number(a.priority) === Number(b.priority);
}
var PayRulesEditor = function () {
    var _a, _b, _c, _d, _e, _f, _g;
    var idCounter = React__namespace.useRef(1);
    var _h = React__namespace.useState(null), savingIndex = _h[0], setSavingIndex = _h[1];
    var _j = React__namespace.useReducer(payRulesReducer, createInitialState(withUiKey(idCounter.current++))), state = _j[0], dispatch = _j[1];
    React__namespace.useEffect(function () {
        idCounter.current = 1;
        Promise.all([fetchPayRules(), fetchPayRuleConstraints()])
            .then(function (_a) {
            var loadedRules = _a[0], loadedConstraints = _a[1];
            var rulesWithIds = loadedRules.map(function (rule, i) { return (__assign(__assign({}, rule), { uiKey: i + 1 })); });
            idCounter.current = rulesWithIds.length + 1;
            dispatch({ type: 'LOAD_SUCCESS', rules: rulesWithIds, constraintOptions: loadedConstraints });
        })
            .catch(function () { return dispatch({ type: 'LOAD_FAILED', error: translate('RULE_DEFINITION.ERROR.LOAD_FAILED') }); });
    }, []);
    // --- Event Handlers ---
    var handleAddRule = React__namespace.useCallback(function () {
        dispatch({ type: 'RULE_ADDED', newRule: withUiKey(idCounter.current++) });
    }, []);
    var handleNewRowSave = React__namespace.useCallback(function (index, rule) { return __awaiter(void 0, void 0, void 0, function () {
        var saved, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setSavingIndex(index);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, createPayRule(rule)];
                case 2:
                    saved = _a.sent();
                    dispatch({ type: 'NEW_ROW_SAVE_SUCCESS', savedRule: __assign(__assign({}, saved), { uiKey: rule.uiKey }), index: index });
                    return [3 /*break*/, 5];
                case 3:
                    err_1 = _a.sent();
                    dispatch({ type: 'SAVE_FAILED', error: getSaveErrorMessage(err_1) });
                    return [3 /*break*/, 5];
                case 4:
                    setSavingIndex(null);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); }, []);
    var handleEditSave = React__namespace.useCallback(function (index, rule) { return __awaiter(void 0, void 0, void 0, function () {
        var isDuplicate, updated, err_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    isDuplicate = state.serverRules.some(function (saved) { return saved.apiId !== rule.apiId && rulesAreEqual(saved, rule); });
                    if (isDuplicate) {
                        dispatch({ type: 'SAVE_FAILED', error: translate('RULE_DEFINITION.ERROR.DUPLICATE_RULE') });
                        return [2 /*return*/, false];
                    }
                    setSavingIndex(index);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, updatePayRule(rule)];
                case 2:
                    updated = _a.sent();
                    dispatch({ type: 'EDIT_SAVE_SUCCESS', updatedRule: __assign(__assign({}, updated), { uiKey: rule.uiKey }), index: index });
                    return [2 /*return*/, true];
                case 3:
                    err_2 = _a.sent();
                    dispatch({ type: 'SAVE_FAILED', error: getSaveErrorMessage(err_2) });
                    return [2 /*return*/, false];
                case 4:
                    setSavingIndex(null);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); }, [state.serverRules]);
    var handleDeleteRequest = React__namespace.useCallback(function (index) {
        dispatch({ type: 'DELETE_REQUESTED', index: index });
    }, []);
    var handleDeleteConfirm = React__namespace.useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var index, rule, err_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    index = state.pendingDeleteIndex;
                    if (index === null)
                        return [2 /*return*/];
                    rule = state.rules[index];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    if (!rule.apiId) return [3 /*break*/, 3];
                    return [4 /*yield*/, deletePayRule(rule.apiId)];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3:
                    dispatch({ type: 'RULE_DELETED', index: index });
                    return [3 /*break*/, 5];
                case 4:
                    err_3 = _a.sent();
                    dispatch({ type: 'SAVE_FAILED', error: getDeleteErrorMessage(err_3) });
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); }, [state.pendingDeleteIndex, state.rules]);
    // --- Render ---
    if (state.isLoading) {
        return React__namespace.createElement(Container, null,
            React__namespace.createElement(lighthouseComponentLibrary.Typography, { use: "body" }, translate('RULE_DEFINITION.LOADING')));
    }
    return (React__namespace.createElement(Container, null,
        React__namespace.createElement(lighthouseComponentLibrary.Typography, { use: "h4", weight: "bold", disableMargins: true }, translate('RULE_DEFINITION.HEADING')),
        React__namespace.createElement(lighthouseComponentLibrary.Toast, { variant: (_b = (_a = state.toast) === null || _a === void 0 ? void 0 : _a.variant) !== null && _b !== void 0 ? _b : 'info', message: ((_c = state.toast) === null || _c === void 0 ? void 0 : _c.variant) === 'success' ? translate(state.toast.message) : (_e = (_d = state.toast) === null || _d === void 0 ? void 0 : _d.message) !== null && _e !== void 0 ? _e : '', open: (_g = (_f = state.toast) === null || _f === void 0 ? void 0 : _f.open) !== null && _g !== void 0 ? _g : false, onClose: function () { return dispatch({ type: 'TOAST_DISMISSED' }); }, dismissible: true, positionVertical: "top" }),
        React__namespace.createElement(lighthouseComponentLibrary.Dialog, { open: state.pendingDeleteIndex !== null, title: translate('RULE_DEFINITION.DELETE_CONFIRM.TITLE'), variant: "warning", rightActions: React__namespace.createElement(React__namespace.Fragment, null,
                React__namespace.createElement(lighthouseComponentLibrary.Button, { type: "outline", text: translate('RULE_DEFINITION.BUTTON.CANCEL'), onClick: function () { return dispatch({ type: 'DELETE_CANCELLED' }); }, "data-qa": "delete-cancel-button" }),
                React__namespace.createElement(lighthouseComponentLibrary.Button, { type: "solid", text: translate('RULE_DEFINITION.BUTTON.DELETE'), onClick: handleDeleteConfirm, "data-qa": "delete-confirm-button" })) },
            React__namespace.createElement(lighthouseComponentLibrary.Typography, { use: "body" }, translate('RULE_DEFINITION.DELETE_CONFIRM.MESSAGE'))),
        React__namespace.createElement(RulesContainer, null, state.rules.map(function (rule, index) { return (React__namespace.createElement(PayRuleRow, { key: rule.uiKey, rule: rule, index: index, constraintOptions: state.constraintOptions, isSaveInProgress: savingIndex === index, onNewRowSave: handleNewRowSave, onNewRowCancel: function (i) { return dispatch({ type: 'NEW_ROW_CANCELLED', index: i }); }, onEditSave: handleEditSave, onDeleteRequest: handleDeleteRequest })); })),
        React__namespace.createElement(StyledAddRuleButton, { "data-qa": "add-rule-button", type: "text", text: translate('RULE_DEFINITION.BUTTON.ADD_RULE'), iconLeft: React__namespace.createElement(lighthouseComponentLibrary.IconV2, { icon: "plus", fontSize: "small" }), onClick: handleAddRule })));
};

var routes = function () {
    return [
        {
            id: RouteIds.PayRulesEditor,
            route: '/pay-rules-editor',
            component: PayRulesEditor,
            restricted: true
        }
    ];
};

var PAY_RULES_EDITOR = {
	TITLE: {
		TARGET: "Pay Rules Editor",
		NOTE: "The title of the Pay Rules Editor page."
	}
};
var RULE_DEFINITION = {
	HEADING: {
		TARGET: "Rule definition",
		NOTE: "Section heading for the pay rule definition form."
	},
	LOADING: {
		TARGET: "Loading...",
		NOTE: "Shown while fetching pay rules and constraint options from the API."
	},
	ERROR: {
		LOAD_FAILED: {
			TARGET: "Failed to load pay rules. Please try again.",
			NOTE: "Error message shown when the initial data fetch fails."
		},
		SAVE_FAILED: {
			TARGET: "Failed to save pay rules. Please try again.",
			NOTE: "Error message shown when saving rules to the API fails."
		},
		DELETE_FAILED: {
			TARGET: "Failed to delete pay rule. Please try again.",
			NOTE: "Error message shown when deleting a rule via the API fails."
		},
		DUPLICATE_RULE: {
			TARGET: "This rule is a duplicate of an existing rule. Please amend it or cancel to exit edit mode.",
			NOTE: "Error shown when the edited rule matches an existing saved rule exactly."
		},
		PERMISSION_DENIED: {
			TARGET: "You do not have permission to perform this action.",
			NOTE: "Error message shown when the API returns a 403 Forbidden response."
		},
		INVALID_RULE: {
			TARGET: "Please complete all required rule fields before saving.",
			NOTE: "Error message shown when a rule is incomplete or invalid at save time."
		}
	},
	SUCCESS: {
		SAVE: {
			TARGET: "Pay rule saved successfully.",
			NOTE: "Success message shown after a rule is saved."
		},
		DELETE: {
			TARGET: "Pay rule deleted successfully.",
			NOTE: "Success message shown after a rule is deleted."
		}
	},
	FIELD: {
		NAME: {
			TARGET: "Name",
			NOTE: "Label for the rule name input field."
		},
		COMPARATOR: {
			TARGET: "Comparator",
			NOTE: "Label for the comparator dropdown (e.g. More than)."
		},
		CONSTRAINT: {
			TARGET: "Constraint",
			NOTE: "Label for the constraint dropdown (e.g. scheduled hours)."
		},
		PERIOD: {
			TARGET: "Period",
			NOTE: "Label for the period dropdown (e.g. day, schedule period)."
		},
		PAY_CODE: {
			TARGET: "Pay code",
			NOTE: "Label for the pay code input field."
		},
		PRIORITY: {
			TARGET: "Priority",
			NOTE: "Label for the priority number input field."
		}
	},
	BUTTON: {
		ADD_RULE: {
			TARGET: "Add Rule",
			NOTE: "Button to add a new rule row."
		},
		EDIT: {
			TARGET: "Edit",
			NOTE: "Tooltip/label for the edit icon button on an existing rule row."
		},
		DELETE: {
			TARGET: "Delete",
			NOTE: "Tooltip/label for the delete icon button on an existing rule row."
		},
		SAVE: {
			TARGET: "Save",
			NOTE: "Button to save the rule definitions."
		},
		CANCEL: {
			TARGET: "Cancel",
			NOTE: "Button to cancel and reset the form."
		},
		CANCEL_EDIT: {
			TARGET: "Cancel edit",
			NOTE: "Tooltip for the inline close button that exits edit mode on a row."
		}
	},
	DELETE_CONFIRM: {
		TITLE: {
			TARGET: "Delete rule",
			NOTE: "Title of the delete confirmation dialog."
		},
		MESSAGE: {
			TARGET: "Are you sure you want to delete this rule? This action cannot be undone.",
			NOTE: "Body text of the delete confirmation dialog."
		}
	}
};
var EnglishUS = {
	PAY_RULES_EDITOR: PAY_RULES_EDITOR,
	RULE_DEFINITION: RULE_DEFINITION
};

var module$1 = {
    setFrameworkInstance: setFrameworkInstance,
    getId: function () { return 'pay-rules-editor'; },
    getName: function () { return 'Pay Rules Editor Module'; },
    getRouteSpecifications: function () { return routes(); },
    getReducers: function () { return ({}); },
    setI18nInstance: function (instance) {
        setFrameworkI18n(instance);
    },
    getI18nResources: function () { return ({
        'en-US': EnglishUS
    }); }
};

exports.Module = module$1;
//# sourceMappingURL=index.js.map
